const quickFilter = <T>(query: string, entities: T[]): T[] =>
    entities.filter((entity) => JSON.stringify(entity).toLowerCase().includes(query.toLowerCase()))

export { quickFilter }
